import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  CompanyCognismTokenQuery,
  DeleteCompanyCognismTokenMutation,
  DeleteCompanyCognismTokenMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { COMPANY_COGNISM_TOKEN_QUERY_KEY } from "./useCompanyCognismToken";

const deleteCompanyCognismToken = graphql(`
  mutation deleteCompanyCognismToken {
    deleteCompanyCognismToken {
      source
      lastFour
    }
  }
`);

export function useDeleteCompanyCognismToken(
  options?: UseMutationOptions<
    DeleteCompanyCognismTokenMutation,
    ClientError,
    DeleteCompanyCognismTokenMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  return useGraphQlMutation(deleteCompanyCognismToken, {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData<CompanyCognismTokenQuery>(COMPANY_COGNISM_TOKEN_QUERY_KEY, {
        companyCognismToken: data.deleteCompanyCognismToken,
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
}
